import React, { useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
import { TablePagination } from '@mui/material';
import { getAccessData } from '../../service/api.service';
import { useNavigate } from 'react-router-dom';
import { EventEmitter } from '../../event';
import { clearLocalStrorage } from '../common/codeHelper';

let rowsValue = [];
function AccessLog(props) {
    const navigate = useNavigate();
    let state = {
        id: '',
        page: 0,
        rowsPerPage: 10,
    }
    const [rows, setRows] = React.useState(rowsValue);
    const [page, setPage] = React.useState({ page: state.page, rowsPerPage: state.rowsPerPage });



    function handleChangePage(event, newPage) {
        setPage({ page: newPage, rowsPerPage: page.rowsPerPage })
    };

    const handleChangeRowsPerPage = (event) => {
        setPage({ page: 0, rowsPerPage: event.target.value })
    };
    function createData(name, browserVersion, operatingSystem, deviceType, browserName, ipAddress) {
        return { name, browserVersion, operatingSystem, deviceType, browserName, ipAddress };
    }
    function getData() {
        rowsValue = []
        getAccessData(resp => {
            if (resp) {
                if (resp.error) {
                    if (resp.type === "REDIRECTLOGIN") {
                        EventEmitter.dispatch("loginChanged", "false");
                        // localStorage.clear();
                        clearLocalStrorage()
                        navigate('./Login', { replace: true });
                    }
                } else {
                    resp.forEach(element => {
                        const accessinfo = element.accessInfo;
                        rowsValue.push(createData(element.accessedByRef.name, accessinfo.browserVersion, accessinfo.operatingSystem, accessinfo.deviceType, accessinfo.browserName, accessinfo.ipAddress))
                    });
                    setRows(rowsValue)
                }

            }
        })
    }
    useEffect(() => {
        if (!rows.length)
            getData();
    })
    return (
        <div>
            <div className="w-full  overflow-hidden " >
                <TableContainer sx={{ maxHeight: 560 }}>
                    <Table stickyHeader aria-label="sticky table" >
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Browser Version</TableCell>
                                <TableCell align="right">OS</TableCell>
                                <TableCell align="right">Device type</TableCell>
                                <TableCell align="right">Browser Name</TableCell>
                                <TableCell align="right">IP Address</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody className='bg-white'>

                            {rows.slice(page.page * page.rowsPerPage, page.page * page.rowsPerPage + page.rowsPerPage)
                                .map((row, index) => {
                                    return (

                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {row.name}
                                            </TableCell>
                                            <TableCell scope="row">
                                                {row.browserVersion}
                                            </TableCell>
                                            <TableCell align="right">{row.operatingSystem}</TableCell>
                                            <TableCell align="right">{row.deviceType}</TableCell>
                                            <TableCell align="right">{row.browserName}</TableCell>
                                            <TableCell align="right">{row.ipAddress}</TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={page.rowsPerPage}
                    page={page.page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );

}

export default AccessLog
